export async function fetchWithRetry(
  requestFactory,
  { retries = 3, delay = 1000, url = "" } = {}
) {
  try {
    const result = await requestFactory();
    return result;
  } catch (error) {
    const isOffline = typeof navigator !== "undefined" && navigator.onLine === false;
    const isTimeout =
      error?.code === "ECONNABORTED" ||
      error?.code === "ETIMEDOUT" ||
      /timeout/i.test(error?.message || "");

    if (retries > 0 && error?.message === "Network Error") {
      await new Promise((res) => setTimeout(res, delay));
      return fetchWithRetry(requestFactory, { retries: retries - 1, delay, url });
    }

    if (error?.message === "Network Error") {
      return {
        data: {
          Status: -999,
          Message: isOffline
            ? "No Internet Connection. Please check your network and try again."
            : "The server did not respond. The request may have timed out. Please try again.",
        },
        status: 0,
        headers: {},
        config: {},
        request: null,
        __networkFallback: true,
        __failedUrl: url,
      };
    }else{
      const responseMessage =
        error?.response?.data?.Error ||
        error?.response?.data?.Message ||
        (isTimeout ? "The request timed out because the server took too long to respond." : error?.message);
      return {
        data: {
          Status: -999,
          Message: responseMessage || "An unexpected error occurred. Please try again later.",
        },
        status: 0,
        headers: {},
        config: {},
        request: null,
        __networkFallback: true,
        __failedUrl: url,
      };
    }
    throw error;
  }
}
